import React from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { connect } from "react-redux"
import { AppState } from "src/store"
import paletteEngine from "../paletteEngine"
import "./DynamicFormsCustomRadio.css"

interface Props {
    callback: Function
    checked: boolean
    title: string
    tooltipText?: string
    tooltipPlacement?: string
    overidePalette?: boolean
}

function DynamicFormsCustomRadio(props: Props) {
    const bgColor = `${paletteEngine.getPaletteColor("fieldInputBackgroundColor")}`
    const color = `${paletteEngine.getPaletteColor("fieldInputTextColor")}`
    const style = props.overidePalette ? {} : { backgroundColor: bgColor, color: color }
    const showTooltip = props.tooltipText ? true : false
    const tooltipText = showTooltip ? props.tooltipText : ""
    const placement = props.tooltipPlacement ? props.tooltipPlacement : "left"

    const DynamicFormsCustomRadioToolTip = (text: string) => (
        <Tooltip id={`dynamic-form-tool-tip-hide-${!showTooltip}`}>
            {text}
        </Tooltip>
    )

    return (
        //@ts-ignore
        <OverlayTrigger placement={placement} overlay={DynamicFormsCustomRadioToolTip(tooltipText)}>
            <div className={`DynamicFormsCustomRadio ${props.checked ? "DynamicFormsCustomRadioChecked" : "DynamicFormsCustomRadioUnchecked"}`}
                //@ts-ignore
                onClick={props.callback}
                style={style}
            >
                <p>{props.title}</p>
            </div>
        </OverlayTrigger>
    )
}

const mapStateToProps = (state: AppState) => ({
    userId: state.user.userId,
    userReference: state.userReference.userReference,
    palette: state.dynamicFormPalette
})

export default connect(mapStateToProps)(DynamicFormsCustomRadio)